import { DeviceTransactionStatus, Networks } from '@iotv/iotv-v3-types';
const defaultSteps = [
    DeviceTransactionStatus.USER_REQUESTED,
    DeviceTransactionStatus.SYSTEM_VERIFIED,
    DeviceTransactionStatus.SENT_TO_NAS,
    DeviceTransactionStatus.QUEUED,
    DeviceTransactionStatus.SENT,
    DeviceTransactionStatus.ACK,
    DeviceTransactionStatus.DEVICE_ACK,
    DeviceTransactionStatus.DEVICE_RESPONSE,
];
const AWS = [
    DeviceTransactionStatus.USER_REQUESTED,
    DeviceTransactionStatus.SYSTEM_VERIFIED,
    DeviceTransactionStatus.SENT_TO_NAS,
    DeviceTransactionStatus.DEVICE_RESPONSE,
];
const ChirpStack = [
    DeviceTransactionStatus.USER_REQUESTED,
    DeviceTransactionStatus.SYSTEM_VERIFIED,
    DeviceTransactionStatus.SENT_TO_NAS,
    DeviceTransactionStatus.SENT,
    DeviceTransactionStatus.DEVICE_RESPONSE,
];
const Spark = [
    DeviceTransactionStatus.USER_REQUESTED,
    DeviceTransactionStatus.SYSTEM_VERIFIED,
    DeviceTransactionStatus.SENT_TO_NAS,
    DeviceTransactionStatus.SENT,
    DeviceTransactionStatus.DEVICE_RESPONSE,
];
const TTNE = [
    DeviceTransactionStatus.USER_REQUESTED,
    DeviceTransactionStatus.SYSTEM_VERIFIED,
    DeviceTransactionStatus.SENT_TO_NAS,
    DeviceTransactionStatus.QUEUED,
    DeviceTransactionStatus.SENT,
    DeviceTransactionStatus.DEVICE_RESPONSE,
];
export const getNetwork = (device) => {
    let network = undefined;
    switch (device.networkKey) {
        case Networks.AWS_LPWAN:
            network = Networks.AWS_LPWAN;
            break;
        case Networks.Chirpstack:
            network = Networks.Chirpstack;
            break;
        case Networks.ThingPark:
            network = Networks.ThingPark;
            break;
        case Networks.TTN_Community:
        case Networks.TTN_Enterprise:
            network = Networks.TTN_Enterprise;
            break;
    }
    return network;
};
export const getNetworkSteps = (network) => {
    let steps = defaultSteps;
    switch (network) {
        case Networks.AWS_LPWAN:
            steps = AWS;
            break;
        case Networks.Chirpstack:
            steps = ChirpStack;
            break;
        case Networks.ThingPark:
            steps = Spark;
            break;
        case Networks.TTN_Enterprise:
            steps = TTNE;
            break;
    }
    return structuredClone(steps);
};
export const getSteps = (steps, currentStatus) => {
    let i = -1;
    switch (currentStatus) {
        case DeviceTransactionStatus.REJECTED_DUPLICATE_DOWNLINK:
            i = steps.findIndex((s) => s === DeviceTransactionStatus.SYSTEM_VERIFIED);
            break;
        case DeviceTransactionStatus.FAILED:
            i = steps.findIndex((s) => s === DeviceTransactionStatus.SENT);
            break;
        case DeviceTransactionStatus.DOWNLINK_CONFIG_ERROR:
            i = steps.findIndex((s) => s === DeviceTransactionStatus.DEVICE_RESPONSE);
            break;
    }
    if (i !== -1 && currentStatus)
        steps.splice(i, 1, currentStatus);
    return steps;
};
